import Immutable from 'immutable';
import {findColorByHex} from '~/constants/InkConstants';
import {makeSpotColor} from '~/utils/colors';

const DEFAULT_CLIPART_VERSION_NAME = 'default';

function deserializeColors(colors) {
  return Immutable.List(
    colors.map(hexString => makeSpotColor(findColorByHex(hexString)))
  );
}

function deserializeClipartVersion(version) {
  return {
    clipartId: version.id.toString(),
    colors: deserializeColors(version.visible_colors),
    blackwhite: version.black_white,
    licensed: version.licensed
  };
}

// Reducert for mapping array of clipart versions to object by version name
export function clipartVersionMapper(reducer, version) {
  reducer[version.version || DEFAULT_CLIPART_VERSION_NAME] =
    deserializeClipartVersion(version);
  return reducer;
}

export function deserializeClipartVersions(data) {
  return data.clipart_versions.reduce(clipartVersionMapper, {});
}
